import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DigitalProductTabSkeleton = () => {
  return (
    <Styles.Container data-testid="digitalProductTabSkeleton">
      <Skeleton variant="text" width={180} height={28} />
      <Skeleton variant="text" width="60%" height={20} />
      <Styles.Content>
        <Styles.Column>
          <Skeleton variant="rounded" width={140} height={40} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width={180} height={40} />
        </Styles.Column>
        <Skeleton variant="rounded" width="100%" height={96} />
      </Styles.Content>
      <Skeleton variant="rounded" width="100%" height={360} />
    </Styles.Container>
  )
}

export default DigitalProductTabSkeleton
